import { Eyebrow, Reveal } from "../Reveal";
import { STEPS } from "../../data/site";

export const Process = () => (
  <section id="process" data-testid="process-section" className="section-pad bg-warm">
    <div className="container-cando">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>How It Works</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="h2 mt-6 max-w-xl text-charcoal">From First Conversation to Final Walkthrough.</h2>
          </Reveal>
        </div>
      </div>

      <div className="mt-16 grid gap-10 md:grid-cols-3 lg:grid-cols-5 lg:gap-6" data-testid="process-steps">
        {STEPS.map((s, i) => (
          <Reveal key={s.key} delay={i * 0.1} className="relative">
            <div data-testid={`process-step-${i}`} className="border-t-2 border-charcoal/15 pt-7">
              <span className="absolute -top-[9px] left-0 h-4 w-4 rotate-45 bg-bronze" />
              <span className="font-heading text-[44px] font-extrabold leading-none tracking-tight text-charcoal/15">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-4 font-heading text-[15px] font-bold uppercase tracking-[0.22em] text-charcoal">
                {s.key}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-mute">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
